import { createI18n } from 'vue-i18n'


const SUPPORTED_LOCALES = ['en'] as const
const DEFAULT_LOCALE = SUPPORTED_LOCALES[0]

export const i18nInstance = createI18n({
  legacy: false,
  locale: DEFAULT_LOCALE,
  messages: {},
})

export const i18n = i18nInstance.global

// vue-i18n v9 calls performance.mark/measure on every t() in dev mode and never
// clears them, pinning ~30 MB of heap per long session. Fixed upstream in v11.
// See https://github.com/intlify/vue-i18n/issues/2462
if (import.meta.env.DEV) {
  setInterval(() => {
    for (const m of performance.getEntriesByType('measure')) {
      if (m.name.startsWith('intlify ')) performance.clearMeasures(m.name)
    }
  }, 30_000)
}
